import { useMemo } from 'react'

import { Loading } from 'components/controls/loading'
import { ErrorInfo } from 'components/controls/errorInfo'

import {
	Box,
	ListProps,
	List,
	Alert
} from '@mui/material'

import { useListLvProject } from 'interface/carenet/lv'
import { LvProjectRecord } from './lvProjectRecord'

type LvProjectListProps = {
	searchId: number,
	searchWord: string,
	openLvProject: (projectCode: string, isOpenGrid: boolean) => void
} & ListProps
export const LvProjectList = ({
	searchId,
	searchWord,
	openLvProject,
	...others
}: LvProjectListProps) => {
	const projectsState = useListLvProject(true, searchId)
	const projects = useMemo(
		() => {
			if (projectsState.loading) return []
			const projects = (projectsState.data?.list || [])
				.filter(project => project.projectName?.toLowerCase().includes(searchWord.toLowerCase()))
			projects.sort((a, b) => (b.broadcastStartDate ?? '').localeCompare(a.broadcastStartDate ?? ''))
			return projects
		},
		[projectsState, searchWord]
	)
	if (projectsState.loading) return <Loading />
	return (
		<>
			{projectsState.error && <ErrorInfo error={projectsState.error} />}

			{(projectsState.data && projects.length === 0) ? (
				<Box padding={1} height='100%' overflow='auto' boxSizing="border-box">
					<Alert severity="info">対象が見つかりません.</Alert>
				</Box>
			) : (
				<List {...others} disablePadding>
					{projects.map(project => (
						<LvProjectRecord
							key={`lv-project-${project.projectCode}`}
							project={project}
							openLvProject={openLvProject}
						/>
					))}
				</List>
			)}
		</>
	)
}
